// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2rRHn","inner":"Footer_inner__2gmwV"};